<template>
    <div class="caption soli-grey">
        {{ lesson.teacher.name }} ·
        {{ lesson.online ? "Online" : lesson.room.title }} ·
        {{ lesson.duration }} min
    </div>
</template>

<script>
export default {
    props: {
        lesson: {
            type: Object,
            default: () => {},
        },
    },
};
</script>
